import React from 'react'
import { compose } from 'recompose'
import { inject, observer } from 'mobx-react'
import { LocaleProvider } from 'antd'
import en from 'antd/lib/locale-provider/en_US'
import th from 'antd/lib/locale-provider/th_TH'
import moment from 'moment'
import 'moment/locale/th'
const locales = {
  en,
  th
}
// console.log({ locales })
const ConnectedLocaleProvider = ({ children, i18n: { locale } }) => ((
  moment.locale(locale),
  <LocaleProvider locale={locales[locale]}>
    {children}
  </LocaleProvider>
))

export default compose(
  inject('i18n'),
  observer
)(ConnectedLocaleProvider)



// WEBPACK FOOTER //
// ./src/App/providers/locale.js